<template>
  <div class="form-card" id="anchor-info">
    <h4>基本資料<span class="must-fill-label">*必須填寫</span></h4>
    <b-row>
      <b-col md="12" class="mb-3">
        <b-form-group label="商戶/商店名稱" label-for="merchantName">
          <AGCSelectGroup
            v-if="role === 'sale' && !inputVal.merchant.name"
            v-model="inputVal.merchant.id"
            :options="merchantOptions"
            rules="required"
            :disabled="readOnly"
            name="商戶/商店名稱"
          ></AGCSelectGroup>
          <b-form-input v-else id="merchantName" :value="inputVal.merchant.name" disabled>
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12" class="mb-3">
        <AGCInput
          v-model.trim="inputVal.reward.name1"
          id="coupon-name"
          name="優惠名稱"
          rules="required|max:50"
          class="mb-3"
          placeholder="優惠名稱"
          required
          :disabled="readOnly"
          label="優惠名稱"
          sub-label="(50字以內)"
          autofocus
        ></AGCInput>
      </b-col>
      <b-col md="12" class="mb-3"
        v-if="role === 'admin' && inputVal.couponMeta.codeType !== 'mc-qr'"
      >
        <AGCInput
          v-model.trim="inputVal.couponMeta.slider"
          id="slider"
          name="Slider文字"
          rules="max:50"
          class="mb-3"
          placeholder="Slider文字"
          :disabled="readOnly"
          label="Slider文字"
          sub-label="(50字以內)"
          autofocus
        ></AGCInput>
      </b-col>
      <b-col md="12" class="mb-3">
        <DropZone
          v-model="inputVal.covers.ulapp"
          :read-only="readOnly"
          rules="required"
          name="封面圖片"
          class="mb-3"
          upload-type="couponCover"
          label="封面圖片"
          id="images"
          sub-label="(最多1張, 每張建議大小600 x 600px 及上限2mb)"
          required
        ></DropZone>
      </b-col>
      <b-col md="12" class="mb-3">
        <DropZone
          v-model="inputVal.images"
          :read-only="readOnly"
          :max-files="5"
          name="圖片集"
          class="mb-3"
          upload-type="couponImages"
          label="圖片集"
          id="images"
          sub-label="(最多5張, 每張建議大小600 x 600px 及上限2mb)"
        ></DropZone>
      </b-col>
      <b-col md="12" class="mb-3 discount-tag">
        <b-tooltip target="tooltip-discount-tag-on-cover" placement="right" variant="light">
          <TooltipDiscountCover
            :cover="inputVal.covers.ulapp | imagePath('couponCover')"
            :tagName="inputVal.reward.tagOnCover"
          ></TooltipDiscountCover>
        </b-tooltip>
        <AGCInput
          v-model.trim="inputVal.reward.tagOnCover"
          id="tag-on-cover"
          name="折扣標籤"
          rules="max:6"
          class="mb-3"
          placeholder="折扣標籤"
          :disabled="readOnly"
          label="折扣標籤"
        >
          <template v-slot:subLabel>
            <span>(最多6個字，例：20%off／-HK$50／買一送一)</span>
            <img
              src="../../assets/img/help-24px-blue.svg"
              alt="Hover for help"
              id="tooltip-discount-tag-on-cover"
            />
          </template>
        </AGCInput>
      </b-col>
      <b-col md="12" class="mb-3">
        <AGCLabel required>優惠使用期限</AGCLabel>
        <AGCDateTimePicker
          v-model="inputVal.couponMeta.startDate"
          rules="required"
          :min="role === 'merchant' ? addDays(new Date(), -1) : null"
          :disabled="readOnly"
          :custom-messages="customMessages.expire"
          label="由"
          name="優惠開始日期"
          class="mb-3"
          style="display:block;"
          has-time
        ></AGCDateTimePicker>
        <AGCDateTimePicker
          v-model="inputVal.couponMeta.expire"
          label="至"
          :rules="{ required: true, dateAfter: [inputVal.couponMeta.startDate, true] }"
          :min="role === 'merchant' ? addDays(new Date(), -1) : null"
          :disabled="readOnly"
          :custom-messages="customMessages.expire"
          name="優惠結束日期"
         class="mb-3"
          style="display:block;"
          has-time
          default-time="23:59:59"
        ></AGCDateTimePicker>
      </b-col>
      <b-col md="12" class="related-link-url mb-3">
         <AGCLabel>
           網店連結
           <template v-slot:subLabel>
             (如優惠只適用於網店，此項為必填項目)
           </template>
          </AGCLabel>
        <div class="d-flex">
          <AGCInput
            v-model.trim="inputVal.reward.relatedLinkUrl"
            name="網店連結"
            id="relatedLinkUrl"
            rules="url"
            class="mb-3 flex-grow-1"
            placeholder="網店連結"
            :disabled="readOnly"
          >
          </AGCInput>
        </div>
      </b-col>
      <b-col md="12" class="mb-3">
        <ContentEditor
          v-model="inputVal.reward.desc"
          name="優惠描述"
          label="優惠描述"
          class="mb-3 desc"
          rules="required"
          upload-type="couponContentImages"
          :read-only="readOnly"
          required
          :toolbar= "toolbarValue"
        ></ContentEditor>

      </b-col>

      <b-col md="12" class="mb-3">
        <ContentEditor
          v-model="inputVal.reward.applicableAddressOrWebsite"
          name="使用指南及適用地址/ 網址"
          label="使用指南及適用地址/ 網址"
          class="mb-3 desc"
          rules="required"
          upload-type="couponContentImages"
          :read-only="readOnly"
          required
          :toolbar= "toolbarValue"
        ></ContentEditor>
      </b-col>
      <b-col md="12" class="mb-3 category-tags">
        <AGCCheckboxGroup
          v-model="inputCategoryTags"
          :disabled="readOnly"
          :options="categoryTagOptions"
          name="分類標籤"
          label="分類標籤"
          sub-label="(可選多項)"
          id="tags"
          :value-field="'id'"
          rules="required"
          required
        ></AGCCheckboxGroup>
      </b-col>
      <b-col md="12" class="mb-3 category-tags" v-if="false">
        <AGCCheckboxGroup
          v-model="inputVal.reward.availableOn"
          :disabled="readOnly"
          :options="platforms"
          name="發佈平台"
          label="發佈平台"
          id="availableOn"
          :value-field="'id'"
          rules="required"
          required
        ></AGCCheckboxGroup>
      </b-col>
      <b-col md="12" class="mb-3 category-tags">
        <AGCCheckboxGroup
          v-model="inputPromoTags"
          :disabled="readOnly"
          :options="promoTagOptions"
          name="推薦標籤"
          label="推薦標籤"
          sub-label="(可選多項)"
          id="cms-tags"
          :value-field="'id'"
        ></AGCCheckboxGroup>
      </b-col>
      <b-col md="12" class="mb-3">
        <ContentEditor
          v-model="inputVal.reward.tnc"
          id="terms"
          class="mb-3 desc"
          upload-type="couponContentImages"
          :read-only="readOnly"
          label="使用條款及細則"
          sub-label="(將連同U Lifestyle之指定免責條款列出)"
          :toolbar= "toolbarValue"
        >
        </ContentEditor>
        <TNC :isUFUN="isUFUN"></TNC>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  BCol, BRow, BFormInput, BFormGroup, BTooltip,
} from 'bootstrap-vue';
import { addDays, formatDate } from '@/helpers/date';
import AGCDateTimePicker from '@/components/form/AGCDateTimePicker.vue';
import AGCSelectGroup from '@/components/form/AGCSelectGroup.vue';
import DropZone from '@/components/form/DropZone.vue';
import ContentEditor from '@/components/editor/ContentEditor.vue';
import TNC from '@/components/coupon/TNC.vue';
import platforms from '@/data/platforms';
import imagePath from '../../filters/image-path';
import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

import TooltipDiscountCover from './TooltipDiscountCover.vue';
import AGCInput from '../form/AGCInput.vue';
import AGCCheckboxGroup from '../form/AGCCheckboxGroup.vue';
import AGCLabel from '../form/AGCLabel.vue';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    TooltipDiscountCover,
    BCol,
    BRow,
    BFormInput,
    BFormGroup,
    BTooltip,
    AGCDateTimePicker,
    AGCSelectGroup,
    DropZone,
    AGCInput,
    AGCCheckboxGroup,
    ContentEditor,
    AGCLabel,
    TNC,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    categoryTagOptions: {
      type: Array,
    },
    promoTagOptions: {
      type: Array,
    },
    merchantOptions: {
      type: Array,
    },
    isUFUN: {
      type: Boolean,
    },
  },
  data: () => ({
    limit: {
      type: 'INFINITY',
      options: [
        { text: '不限', value: 'INFINITY' },
        { text: '自訂', value: 'CUSTOM' },
      ],
    },
    platforms,
    quantityRules: {},
    radioDefault: 'default',
    key: -1,
    customMessages: {
      expire: {
        dateAfter: (_, { minDate }) => `優惠使用期限只能選擇 ${formatDate(minDate, true)} 之後`,
      },
    },
    toolbarValue: [`
          undo redo |
          bold italic underline |
          alignleft aligncenter alignright alignjustify |
          bullist numlist outdent indent |
          link |
          `],
  }),
  computed: {
    ...mapGetters(['role']),
    inputCategoryTags: {
      get() {
        if (!this.categoryTagOptions) return null;
        if (!this.inputVal) return null;
        const categoryTagIds = this.categoryTagOptions.map((tag) => tag.id);
        const inputTagIds = this.inputVal.categoryTags || this.inputVal.tags;
        return inputTagIds.filter((tagId) => categoryTagIds.includes(tagId));
      },
      set(newValue) {
        this.inputVal.categoryTags = newValue;
      },
    },
    inputPromoTags: {
      get() {
        if (!this.promoTagOptions) return null;
        if (!this.inputVal) return null;
        const promoTagIds = this.promoTagOptions.map((tag) => tag.id);
        const inputTagIds = this.inputVal.promoTags || this.inputVal.tags;
        return inputTagIds.filter((tagId) => promoTagIds.includes(tagId));
      },
      set(newValue) {
        this.inputVal.promoTags = newValue;
      },
    },
  },
  methods: {
    addDays,
  },
  filters: {
    imagePath,
  },
};
</script>

<style lang="scss" scoped>
label + #keyword-filter {
  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.must-fill-label {
  float: right;
  font-size: 14px;
  color: #f54b4e;
  font-weight: 400;
}

::v-deep.desc{
    img {
        max-width: 100% !important;
      }
  }
</style>
